<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Photo' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="card bg-light">
      <div class="card-body">

        <h4 class="card-title">{{'Upload a new photo' | translate}}</h4>

        <div class="form-group">
          <label>{{'Title' | translate}}</label>
          <input class="form-control" [(ngModel)]="entity.title" />
        </div>

        <div class="form-group">
          <label>{{'Description' | translate}}</label>
          <textarea rows="5" class="form-control" [(ngModel)]="entity.description"></textarea>
        </div>

        <div class="form-group">
          <label>{{'Photo' | translate}}</label>
          <div class="custom-file">
            <input type="file" class="custom-file-input" (change)="onFilePhotoChange($event)" [(ngModel)]="entity.photoFile" id="photoFile">
            <label class="custom-file-label" for="photoFile" [attr.data-browse]="'Select file' | translate">{{'Upload a new photo' | translate}}</label>
          </div>
          <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'photoFile')">
            <p>{{'Please select a file' | translate}}</p>
          </div>
        </div>

        <div class="btn-toolbar">
          <button class="btn btn-primary ml-auto" (click)="addPhoto()">
            <fa-icon *ngIf="isProcessing" [icon]="faSpinner" animation="spin"></fa-icon>
            {{'Add' | translate}}
          </button>
        </div>

        <div class="mt-3 alert alert-success" *ngIf="isUploaded">
          {{ 'Successfully added' | translate }}
        </div>

      </div>
    </div>

    <div class="card mt-4" *ngIf="view.data.length > 0">
      <div class="card-body">

        <h4 class="card-title">{{'Saved photos' | translate}}</h4>

        <table class="table table-striped table-company-photo">

          <thead>
            <tr>
              <th>
                {{'Image' | translate}}
              </th>
              <th>
                {{'Title' | translate}}
              </th>
              <th>
                {{'Description' | translate}}
              </th>
              <th>

              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let photo of view.data">
              <td>
                <img class="img-fluid img-responsive img-64" [src]="photo['imageUri']" />
              </td>
              <td>
                {{photo.title}}
              </td>
              <td>
                {{photo.description}}
              </td>
              <td>
                <button class="btn btn-danger" (click)="deletePhoto(photo.id)">
                  <fa-icon [icon]="faTimes"></fa-icon>
                </button>
              </td>

            </tr>
          </tbody>

        </table>

      </div>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-end">
      <button type="button" class="btn btn-primary" (click)="activeModal.close(true)">{{'Close' | translate}}</button>
    </div>
  </div>
</div>
